import React, { useEffect } from "react";
import Aos from "aos";

const Services = () => {
  useEffect(() => {
    Aos.init({ duration: 1000 });
  }, []);
  return (
    <div className="services" id="services">
      <video src="/videos/video-5.mp4" autoPlay loop muted />
      <div className="container">
        <div className="services-header">
          <div className="row">
            <div className="col-md-4">
              <div
                data-aos="flip-left"
                data-aos-delay="400"
                className="service-box"
              >
                <img
                  src="https://freepngimg.com/thumb/school/23847-3-school-file-thumb.png"
                  className="img-fluid"
                />
                <div className="service-box-header">
                  Computer Science Education
                </div>
                <div className="service-box-p">
                  I have working knowledge of mathematics, statistics and
                  computer sciences. I'm well-equiped with necessary knowledge
                  and skills to solve real life problems.
                </div>
              </div>
            </div>
            <div className="col-md-4">
              <div data-aos="flip-left" className="service-box">
                <img
                  src="https://freepngimg.com/thumb/web_development/8-2-web-development-png-file-thumb.png"
                  className="img-fluid"
                />
                <div className="service-box-header">Web Development</div>
                <div className="service-box-p">
                  I like to code things from scratch, and enjoy bringing ideas
                  to life in the browser using the latest tools.
                  <p></p>
                </div>
              </div>
            </div>
            <div className="col-md-4">
              <div
                data-aos="flip-left"
                data-aos-delay="200"
                className="service-box"
              >
                <img
                  src="https://freepngimg.com/thumb/responsive_web_design/2-2-responsive-web-design-free-png-image-thumb.png"
                  className="img-fluid"
                />
                <div className="service-box-header">Responsive Web Design</div>
                <div className="service-box-p">
                  I value simple content structure, clean, responsive design
                  patterns, and thoughtful interactions.
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Services;
